var deepMerge = require('deepmerge');
var _config = require('./config');
var _require = require('./default'),
  setting = _require.setting;
var config = deepMerge(setting, _config);
module.exports = config;